'use client';
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import AuthBrandPanel from './AuthBrandPanel';

export default function AuthScreen() {
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-5/12">
        <AuthBrandPanel />
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 bg-background min-h-screen">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center justify-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-xl gradient-green flex items-center justify-center text-white font-extrabold text-lg">
              FE
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-bold text-sm text-foreground leading-none">Fluent English</span>
              <span className="font-semibold text-xs text-primary leading-none">Blueprint</span>
            </div>
          </div>

          {/* Tab toggle */}
          <div className="flex items-center gap-1 p-1 rounded-2xl bg-muted border border-border mb-8">
            <button
              onClick={() => setActiveTab('login')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 ${
                activeTab === 'login' ?'bg-card shadow-card text-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all duration-200 ${
                activeTab === 'signup' ?'bg-card shadow-card text-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Form */}
          <div className="fade-in">
            {activeTab === 'login' ? (
              <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
            ) : (
              <SignupForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}